import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../contactUs/image/corporate_icon01.png';
import _imports_1 from '../../contactUs/image/corporate_icon03.png';
import _imports_2 from '../../contactUs/image/corporate_icon05.png';
import _imports_3 from '../../contactUs/image/corporate_icon02.png';
import _imports_4 from '../images/cn_map.png';
var _hoisted_1 = {
  class: "abt_contact_bg_box"
};
var _hoisted_2 = {
  class: "abt_contact_us container"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "abt_contact_us_img"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "abt_contact_us_big_text",
  id: "contactUs"
}, "联系我们")], -1);

var _hoisted_4 = {
  class: "abt_contact_us_left col-lg-5 col-md-5 col-sm-12 col-xs-12"
};
var _hoisted_5 = {
  class: "abt_corporate_name"
};
var _hoisted_6 = {
  class: "abt_corporate_box"
};

var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "abt_corporate_icon_box acib_01"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "corporate_icon01"
})], -1);

var _hoisted_8 = {
  class: "abt_corporate_text act_01"
};
var _hoisted_9 = {
  class: "abt_corporate_box"
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "abt_corporate_icon_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "corporate_icon03"
})], -1);

var _hoisted_11 = {
  class: "abt_corporate_text"
};
var _hoisted_12 = {
  class: "abt_corporate_box"
};

var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "abt_corporate_icon_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "corporate_icon05"
})], -1);

var _hoisted_14 = {
  class: "abt_corporate_text"
};
var _hoisted_15 = {
  class: "abt_corporate_box"
};

var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "abt_corporate_icon_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "corporate_icon02"
})], -1);

var _hoisted_17 = {
  class: "abt_corporate_text"
};

var _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "abt_contact_us_right col-lg-7 col-md-7 col-sm-12 col-xs-12"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "map_img"
})], -1);

var _hoisted_19 = /*#__PURE__*/_createTextVNode("Click to upload");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_upload = _resolveComponent("el-upload");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.contactUsInfo.companyName), 1), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, " 地址：" + _toDisplayString(_ctx.contactUsInfo.companyAddress), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, "邮编：" + _toDisplayString(_ctx.contactUsInfo.companyPostCode), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, "邮箱：" + _toDisplayString(_ctx.contactUsInfo.companyEmail), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, "热线：" + _toDisplayString(_ctx.contactUsInfo.companyHotPhone), 1)])]), _hoisted_18])]), _createVNode(_component_el_upload, {
    "file-list": _ctx.fileList,
    "onUpdate:file-list": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.fileList = $event;
    }),
    class: "upload-demo",
    action: "https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15",
    "on-change": _ctx.handleChange
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        ref: "upLoadBtn",
        type: "primary"
      }, {
        default: _withCtx(function () {
          return [_hoisted_19];
        }),
        _: 1
      }, 512)];
    }),
    _: 1
  }, 8, ["file-list", "on-change"])], 64);
}